import { error as errorReducer } from './Error.reducer';
import {
    INVOICES_RECEIVE,
    INVOICES_ERROR
} from '../Actions/Invoices.action';

const defaultState = {
    errors: {}
};

export const invoices = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case INVOICES_RECEIVE:
            return {
                ...state,
                errors: {},
                ...payload,
            };
        case INVOICES_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action),
            };
        default:
            return state;
    }
};
